import { HttpParams } from "@angular/common/http";
import { IPagination, IQueryParamsBody } from "./general.interface";

export class HelperFunctions{

  public static isStaticMinimized() {
    return window.innerWidth < 1130 && window.innerWidth > 600;
  }
  public static isOverlay(){
    return window.innerWidth <= 600
  }

  static addPaginationToParams(params: HttpParams, paginationParams: IPagination): HttpParams {
    params = params.append('currentPage', paginationParams.pageNumber);
    params = params.append('pageSize', paginationParams.pageSize);

    return params;
  }

  public static buildPageQueryParams(page: number = 1, pageSize: number = 10, sortBy: string = 'lastModified', sortDir: string, searchValue?: string): HttpParams {
    let queryParams: HttpParams = new HttpParams;
    queryParams = queryParams.append('currentPage', page);
    queryParams = queryParams.append('pageSize', pageSize);
    queryParams = queryParams.append('sortField', sortBy);
    queryParams = queryParams.append('sortOrder', sortDir);
    if(searchValue)
       queryParams = queryParams.append('searchValue', searchValue);

    return queryParams
  }

  public static buildPagePoliticalWingQueryParams(politicalWings: string[] = [], politicianId = "ALL", page: number = 1, pageSize: number = 10, sortBy: string = 'lastModified', sortDir: string, searchValue?: string): HttpParams {
    let queryParams: HttpParams = new HttpParams;
  
    if (politicalWings) {
      // Handle both array and single string case for politicalWings
      if (Array.isArray(politicalWings)) {
        if (politicalWings.length > 0) {
          if (politicalWings.length == 1)
            queryParams = queryParams.append('politicalWings', politicalWings[0]);
          else
          queryParams = queryParams.append('politicalWings', politicalWings.join(','));
        }
      }
    }
  
    queryParams = queryParams.append('politicianId', politicianId);
    queryParams = queryParams.append('currentPage', page);
    queryParams = queryParams.append('pageSize', pageSize);
    queryParams = queryParams.append('sortField', sortBy);
    queryParams = queryParams.append('sortOrder', sortDir);
    if (searchValue)
      queryParams = queryParams.append('searchValue', searchValue);
  
    return queryParams;
  }

  public static buildInitialParams = (sortBy?: string, pageSize?: number): IQueryParamsBody => {
    let body: IQueryParamsBody = {
      page: 1,
      pageSize: pageSize ?? 10,
      sortBy: sortBy ?? 'name',
      sortDir: 'desc'
    }
    return body
  }

  public static formatDate(inputDate: string): string {
    const date = new Date(inputDate);
  
    // Ensure that the date is valid
    if (isNaN(date.getTime())) {
      return 'Invalid Date';
    }
  
    const day: string = String(date.getDate()).padStart(2, '0');
    const month: string = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const year: string = String(date.getFullYear());
  
    return `${day}-${month}-${year}`;
  }

  
  public static formatDatetime(time: string): string {
    if (!time) return '';
    try {
      const date = new Date(time);
      
      // Get day, month, year
      const day = date.getDate().toString().padStart(2, '0');
      const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Month is 0-indexed
      const year = date.getFullYear();
      
      // Get hours and minutes
      const hours = date.getHours().toString().padStart(2, '0');
      const minutes = date.getMinutes().toString().padStart(2, '0');
      
      // Format as DD-MM-YYYY HH:MM
      return `${day}-${month}-${year} ${hours}:${minutes}`;
    } catch (e) {
      console.error('Error formatting date:', e);
      return time;
    }
  }


/**
 * Extracts initials from a name string in capital letters
 * @param fullName The full name (e.g., "Name Surname" or "Name Middle Surname")
 * @returns Initials in capital letters (e.g., "NS")
 */
public static getInitials(fullName: string): string {
  if (!fullName || fullName.trim() === '') {
    return '';
  }
  
  // Split the name by spaces
  const nameParts = fullName.trim().split(' ');
  
  // Get first initial (first character of first part)
  const firstInitial = nameParts[0].charAt(0);
  
  // Get last initial (first character of last part)
  const lastInitial = nameParts[nameParts.length - 1].charAt(0);
  
  // Return combined initials in uppercase
  return (firstInitial + lastInitial).toUpperCase();
}

/*
 public static initAllListParams = (): IParamsAndBody => {
    let params: IParamsAndBody = {
      page: 1,
      pageSize: 99999,
      sortBy: 'dateCreated',
      sortDir: 'desc',
      searchValue: '',
      body: []
    }
    return params
 }


 public static buildFilterBody = (propertyName: string, value: string): IFilterBody => {
    return {
      propertyName: propertyName,
      value: value
    }
 }
 */
}
